var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"editor-content"},[_c('iframe',{ref:"iframe",staticStyle:{"display":"1","height":"93%","width":"90%","position":"absolute"},attrs:{"scrolling":"no","src":_vm.editor}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }